// components/Navbar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Navbar.css";

const plannerDesktopLinks = [
  { to: "/", label: "Home" },
  { to: "/heathrow", label: "Heathrow" },
  { to: "/east-midlands-airport", label: "East Midlands Airport" },
  { to: "/flight-checker", label: "Live Flight Checker" },
  { to: "/international-students/uk-arrival-guide", label: "Student Arrival" },
  { to: "/contact", label: "Contact" },
];

const plannerMobileLinks = [
  { to: "/", label: "Home" },
  { to: "/heathrow", label: "Heathrow" },
  { to: "/east-midlands-airport", label: "East Midlands Airport" },
  { to: "/flight-checker", label: "Live Flight Checker" },
  { to: "/international-students/uk-arrival-guide", label: "Student Arrival" },
  { to: "/contact", label: "Contact" },
];

const ccgDesktopLinks = [
  { to: "/", label: "Home" },
  { to: "/minibus-hire", label: "Minibus Hire" },
  { to: "/coach-hire", label: "Coach Hire" },
  { to: "/group", label: "CheapCabGrab Group" },
  { to: "/contact", label: "Contact" },
  { to: "/faq", label: "FAQs" },
];

const ccgMobileLinks = [
  { to: "/", label: "Home" },
  { to: "/minibus", label: "Minibus Hire" },
  { to: "/coach", label: "Coach Hire" },
  { to: "/group", label: "CheapCabGrab Group" },
  { to: "/services", label: "Our Services" },
  { to: "/contact", label: "Contact" },
  { to: "/faq", label: "FAQs" },
];

export default function Navbar(props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const siteMode = props?.siteMode || process.env.REACT_APP_SITE_MODE || "ccg";
  const isPlanner =
    props?.isPlanner || siteMode === "planner";
  const isMinibusGrab = siteMode === "minibusgrab";
  const isCoachGrab = siteMode === "cheapcoachgrab";
  const brandName = isPlanner ? "Airport Journey Planner" : isMinibusGrab ? "MinibusGrab" : isCoachGrab ? "CheapCoachGrab" : "CheapCabGrab";
  const logoSrc = isPlanner ? "/logo-ajp.webp" : logo;
  const minibusDesktopLinks = [
    { to: "/", label: "Home" },
    { to: "/minibus-hire", label: "Minibus Hire" },
    { to: "/heathrow-minibus", label: "Heathrow Minibus" },
    { to: "/coach-hire", label: "Coach Hire" },
    { to: "/contact", label: "Contact" },
  ];
  const minibusMobileLinks = [
    { to: "/", label: "Home" },
    { to: "/minibus-hire", label: "Minibus Hire" },
    { to: "/heathrow-minibus", label: "Heathrow Minibus" },
    { to: "/coach-hire", label: "Coach Hire" },
    { to: "/contact", label: "Contact" },
    { to: "/faq", label: "FAQs" },
  ];
  const coachDesktopLinks = [
    { to: "/", label: "Home" },
    { to: "/coach-hire", label: "Coach Hire" },
    { to: "/heathrow-coach-hire", label: "Heathrow Coach" },
    { to: "/minibus-hire", label: "Minibus Hire" },
    { to: "/contact", label: "Contact" },
  ];
  const coachMobileLinks = [
    { to: "/", label: "Home" },
    { to: "/coach-hire", label: "Coach Hire" },
    { to: "/heathrow-coach-hire", label: "Heathrow Coach" },
    { to: "/minibus-hire", label: "Minibus Hire" },
    { to: "/contact", label: "Contact" },
    { to: "/faq", label: "FAQs" },
  ];
  const desktopLinks = isPlanner ? plannerDesktopLinks : ccgDesktopLinks;
  const mobileLinks = isPlanner ? plannerMobileLinks : isMinibusGrab ? minibusMobileLinks : isCoachGrab ? coachMobileLinks : ccgMobileLinks;
  const resolvedDesktopLinks = isPlanner ? plannerDesktopLinks : isMinibusGrab ? minibusDesktopLinks : isCoachGrab ? coachDesktopLinks : desktopLinks;

  return (
    <>
      {/* BACKDROP */}
      {menuOpen && (
        <div className="nav-backdrop" onClick={() => setMenuOpen(false)}></div>
      )}




<nav className={`nav-container ${isPlanner ? "planner-nav" : ""} ${isMinibusGrab || isCoachGrab ? "minibus-nav" : ""} ${isMinibusGrab ? "minibus-site-nav" : ""} ${isCoachGrab ? "coach-site-nav" : ""}`}>

  {/* LEFT: Hamburger + Logo */}
  <div className="nav-left">
    <div className="nav-hamburger" onClick={() => setMenuOpen(true)}>
      ☰
    </div>
    <Link
      to="/"
      onClick={() => setMenuOpen(false)}
      style={{ display: "flex", alignItems: "center", gap: isMinibusGrab || isCoachGrab ? "8px" : "10px", textDecoration: "none", minWidth: 0 }}
    >
      <img src={logoSrc} alt={`${brandName} Logo`} height={isMinibusGrab || isCoachGrab ? 32 : 45} style={isMinibusGrab || isCoachGrab ? { width: 32, objectFit: "contain", flex: "0 0 auto" } : undefined} />
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1, minWidth: 0 }}>
        <span style={{ display: "block", color: "#111", fontSize: isMinibusGrab || isCoachGrab ? "15px" : "16px", fontWeight: 700, whiteSpace: isMinibusGrab || isCoachGrab ? "nowrap" : "normal" }}>{brandName}</span>
        {isPlanner && (
          <span style={{ color: "#666", fontSize: "11px", fontWeight: 600 }}>
            Powered by CheapCabGrab
          </span>
        )}
      </div>
    </Link>
  </div>

  {/* RIGHT: Mobile Driver Button OR Desktop Menu */}
  <div className="nav-right-wrapper">

    {/* MOBILE CTA */}
    {!isPlanner && !isMinibusGrab && !isCoachGrab && (
      <Link to="/driver" className="nav-mobile-driver-btn">
        Driver Sign Up
      </Link>
    )}

    {/* DESKTOP LINKS */}
    <div className="nav-links">
      {resolvedDesktopLinks.map((link) => (
        <Link key={link.to} to={link.to}>
          {link.label}
        </Link>
      ))}
    </div>

    {(isMinibusGrab || isCoachGrab) && (
      <Link to="/" className="minibus-nav-quote-btn">
        Get a quote
      </Link>
    )}

    {/* DESKTOP DRIVER CTA */}
    {!isPlanner && !isMinibusGrab && !isCoachGrab && (
      <Link to="/driver" className="desktop-driver-btn">
        Driver Sign Up
      </Link>
    )}

  </div>

</nav>




      {/* MOBILE DRAWER */}
      <div className={`nav-drawer ${menuOpen ? "open" : ""}`}>
        {mobileLinks.map((link) => (
          <Link key={link.to} to={link.to} onClick={() => setMenuOpen(false)}>
            {link.label}
          </Link>
        ))}
        {isPlanner && (
          <div style={{ marginTop: "8px", color: "#666", fontSize: "13px", fontWeight: 600 }}>
            Powered by CheapCabGrab
          </div>
        )}
        <hr />

      </div>
    </>
  );
}
